export default __webpack_public_path__ + "static/media/compass7.b3bcb04d.png";